import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { SearchResultsSection } from '../SearchResultsSection/SearchResultsSection'

import { AppRoute } from '@percent/workplace-giving/routing/AppRoute.enum'
import { formatNumberToLocale } from '@percent/workplace-giving/utils/formatNumberToLocale/formatNumberToLocale'
import { GetAccountGivingActionsResponse } from '@percent/workplace-giving/api/account/givingActions/getAccountGivingActions/getAccountGivingActions.types'
import { GivingActionCardSkeleton } from '@percent/workplace-giving/common/components/GivingActionCard/GivingActionCardSkeleton'
import { useGivingActionInteractions } from '@percent/workplace-giving/common/components/GivingActionCard/useGivingActionInteractions'

type GivingActionsResultsProps = Readonly<{
  data?: GetAccountGivingActionsResponse
  isFetching: boolean
  query?: string
}>

export function GivingActionsResults({ data, isFetching, query }: GivingActionsResultsProps) {
  const {
    t,
    i18n: { language }
  } = useTranslation()
  const { renderCard, overlays } = useGivingActionInteractions({ showCampaignName: true })

  const items = useMemo(
    () => data?.data?.map(row => ({ id: row.id, content: renderCard(row) })) ?? [],
    [data, renderCard]
  )

  return (
    <SearchResultsSection
      testId="giving-actions-results"
      title={t('workplace_giving.globalSearch.searchResults.givingActions', {
        totalResults: formatNumberToLocale(language, data?.totalResults || 0)
      })}
      noResultsText={t('workplace_giving.globalSearch.searchResults.noGivingActions')}
      totalResults={data?.totalResults || 0}
      isFetching={isFetching}
      items={items}
      skeleton={<GivingActionCardSkeleton />}
      seeAllTo={`${AppRoute.GIVING_ACTIONS}?query=${query}`}
    >
      {overlays}
    </SearchResultsSection>
  )
}
